import { ReduxState } from 'src/store/types';

export const namedGraphsSelector =
  (databaseId: string) => (state: ReduxState) =>
    state.databases.databasesById[databaseId]?.namedGraphs || {};
